import React, { useState, useEffect } from 'react';
import { initialFormData } from '../lib/onboardingSchema';
import { trackEvent, EVENTS } from '../lib/plgTracking';
import BusinessInfoStep from './BusinessInfoStep';
import ReviewGoalStep from './ReviewGoalStep';
import IntegrationStep from './IntegrationStep';
import SuccessStep from './SuccessStep';

const STEPS = [
  { id: 1, title: 'Business Info' },
  { id: 2, title: 'Review Goals' },
  { id: 3, title: 'Integration' },
  { id: 4, title: 'Success' }
];

export default function OnboardingShell() {
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    trackEvent(EVENTS.STARTED, { timestamp: new Date() });
  }, []);

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleNext = () => {
    if (currentStep === 1) trackEvent(EVENTS.STEP_1_COMPLETED, { businessName: formData.businessName });
    if (currentStep === 2) trackEvent(EVENTS.STEP_2_COMPLETED, { goals: formData.primaryGoal });
    if (currentStep === 3) trackEvent(EVENTS.STEP_3_COMPLETED, { crm: formData.crmSource });
    
    if (currentStep < 4) {
      setCurrentStep(prev => prev + 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(prev => prev - 1);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1: return <BusinessInfoStep data={formData} onChange={handleChange} onNext={handleNext} />;
      case 2: return <ReviewGoalStep data={formData} onChange={handleChange} onNext={handleNext} onBack={handleBack} />;
      case 3: return <IntegrationStep data={formData} onChange={handleChange} onNext={handleNext} onBack={handleBack} />;
      case 4: return <SuccessStep data={formData} />;
      default: return null;
    }
  };

  const progressPercentage = ((currentStep - 1) / (STEPS.length - 1)) * 100;

  return (
    <div className="bg-white rounded-2xl shadow-glow-teal border border-gray-100 overflow-hidden">
      {/* Progress Header */}
      <div className="bg-brand-deep p-6 sm:px-10 relative overflow-hidden">
        <div className="absolute top-0 left-0 h-1 bg-brand-accent transition-all duration-500 ease-out" 
             style={{ width: `${progressPercentage}%` }} />
        
        <div className="flex justify-between items-center relative z-10">
          <div>
            <h2 className="text-white text-xl sm:text-2xl mb-1">Step {currentStep}</h2>
            <p className="text-brand-signal text-sm font-lexend">{STEPS[currentStep - 1].title}</p>
          </div>
          <div className="hidden sm:flex space-x-2">
            {STEPS.map((s) => (
              <div key={s.id} 
                   className={`h-2 w-8 rounded-full transition-colors duration-300 ${s.id <= currentStep ? 'bg-brand-accent' : 'bg-white/20'}`} />
            ))}
          </div>
        </div>
      </div>

      {/* Step Content */}
      <div className="p-6 sm:p-10">
        {renderStep()}
      </div>
    </div>
  );
}